// DevHub: tiny debounce hook. Returns a copy of `value` that only updates after `delay` ms have
// passed with no further change. Used to keep search INPUTS instant (controlled state updates every
// keystroke) while the NETWORK query the input drives fires only once the user pauses — a dev once
// took the backend down by spamming letters into an un-debounced search box.
import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
